import React, { useState } from 'react';
import injectSheet from 'react-jss';
import classNames from 'classnames';

import HeaderLink from './HeaderLink';
import { Row, Block, Button, StickyWrapper } from '../common';
import theme, { mediaQueryMobile } from '../../theme';

// TODO - move to theme
export const headerHeight = 100;

const styles = {
  container: {
    backgroundColor: theme.palette.primary.main,
    height: headerHeight,
  },
  mobileMenuControl: {
    display: 'none',
  },
  [mediaQueryMobile]: {
    mobileMenuControl: {
      display: 'flex',
    },
    mobileMenuControlActive: {
      zIndex: 100001,
    },
    links: {
      position: 'fixed',
      flexDirection: 'column',
      width: '100%',
      top: -1500,
      height: '100vh',
      transition: 'height 1s linear, top 0.25s linear, background 0.25s linear',
    },
    linksActive: {
      top: 0,
      background: 'rgba(0, 0, 0, 0.9)',
      zIndex: 10000,
      fontSize: 24,
      color: 'white',
    },
  },
};

const Header = ({ classes, headerLinks, isSticky }) => {
  let [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
  return (
    <StickyWrapper isSticky={isSticky}>
      <Block className={classNames(classes.container)}>
        <Block
          className={classNames(
            classes.mobileMenuControl,
            isMobileMenuOpen ? classes.mobileMenuControlActive : null
          )}
        >
          <Button onClick={() => setMobileMenuOpen(!isMobileMenuOpen)}>
            Toggle Menu
          </Button>
        </Block>
        <Row
          className={classNames(
            classes.links,
            isMobileMenuOpen ? classes.linksActive : null
          )}
        >
          <Block centered>
            <HeaderLink target="/#home" text="Home" />
          </Block>
          {headerLinks.map(link => (
            <Block key={link.id} centered>
              <HeaderLink
                type="anchor"
                target={link.anchor}
                text={link.title}
              />
            </Block>
          ))}
        </Row>
      </Block>
    </StickyWrapper>
  );
};

export default injectSheet(styles)(Header);
